let configDataset = JSON.parse(document.getElementById("config").dataset.config)
export const Config = Object.freeze(Object.assign({}, configDataset))
